<template>

  <el-dialog title="" :visible.sync="dialogFormVisible">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="密码登录" name="first">
        <el-form :model="form" status-icon :rules="rules" ref="form">
          <el-form-item prop="username">
            <el-input v-model="form.username" placeholder="请输入用户名/手机号" ref="username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" placeholder="请输入6-16位字符的密码" ref="password" type="password" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>

        <div class="login">
          <el-button type="primary" :disabled="btnState===false" :class="{btnBg:btnState}" @click="toLogin" @keyup.enter="keyDown">登录</el-button>
        </div>
        <div class="noPwd" @click="updateDialog('update')">忘记密码</div>
      </el-tab-pane>

      <el-tab-pane label="手机注册" name="second">
        <el-form :model="registerForm" class="reg">
          <el-form-item>
            <el-input v-model="registerForm.username" placeholder="请输入用户名" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.phone" placeholder="请输入手机号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="registerForm.password" placeholder="请输入6-16位字符的密码" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <div class="yzm">
            <div>
              <el-input v-model="registerForm.code" placeholder="请输入短信验证码" autocomplete="off"></el-input>
            </div>
            <div>
              <button type="button" class="txt btn cursorPointer" @click="getYzm">{{codeText}}</button>
            </div>
          </div>
        </el-form>
        <div class="register">
          <el-button type="primary" :disabled="btnRegState===false" :class="{btnBg:btnRegState}" @click="toRegister">注册</el-button>
        </div>

      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer">

    </div>
    <forgetPwd v-if="VisiAblePwd" ref="dialog"></forgetPwd>
  </el-dialog>
</template>

<script>
import ForgetPwd from "./ForgetPwd";
import { Login, Register, Code } from "@/api/user";
export default {
  name: "Login",
  components:{
    ForgetPwd
  },
  data() {
    // 对用户名进行校验
    const validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名或手机号'))
      } else {
        callback()
      }
    };
    // 对密码进行校验
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(('请输入密码')))
      } else {
        callback()
      }
    };
    return {
      codeText: '获取验证码',
      activeName: 'first',
      dialogFormVisible: false,
      VisiAblePwd: false,
      form: {
        username: '',
        password: '',
      },
      registerForm: {
        username: '',
        phone: '',
        password: '',
        code: '',
      },
      rules: {
        username: [
          //trigger: 'blur'：当失去焦点时（光标不显示的时候），触发此提示
          { validator: validateName, message: '请输入用户名/手机号', trigger: 'blur'}
        ],
        password: [
          { validator: validatePassword, message: '请输入密码', trigger: 'blur'}
        ]
      },
    }
  },
  created(){
    // this.toLogin();
    // this.toRegister();
  },
  mounted() {
    window.addEventListener('keydown',this.keyDown);
  },
  computed :{
    btnState(){//当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.form.username !== "" && this.form.password !==""
    },
    btnRegState(){//当用户名和密码框都不为空时btnRegState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.registerForm.username !== "" && this.registerForm.password !=="" && this.registerForm.phone !=="" && this.registerForm.code !==""
    }
  },
  destroyed(){
    window.removeEventListener('keydown',this.keyDown,false);
  },
  methods: {
    updateDialog(data) {
      this.VisiAblePwd=true;
      this.$nextTick(()=>{
        this.$refs.dialog.init(data);
      })
    },
    init(data){
      this.dialogFormVisible=true;
      //data是父组件弹窗传递过来的值，我们可以打印看看
      // console.log(data);
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    keyDown(e){
      //如果是回车则执行登录方法
      if(e.keyCode === 13){
        //需要执行的登录方法
        this.toLogin();
      }
    },
    toLogin(){
      let data = {
        username: this.form.username,
        password: this.form.password
      };
      Login( data ).then(( response ) => {
        // console.log( response );
        if(response.code === 2000){
          this.dialogFormVisible = false;
          this.$message.success({message:'登录成功',duration:1000,offset:400})
          window.localStorage.setItem('username',this.form.username)
          window.localStorage.setItem('token',response.data)
          window.localStorage.setItem('phone',response.msg)
          this.$router.go(0)
        }else if(response.code === 400){
          this.$message({
            message: '输入的账号或密码错误',
            type: 'warning',
            duration:1500,
            offset:400,
            customClass:'error-lg'
          })
        }
      });
    },
    toRegister(){
      let data = {
        username: this.registerForm.username,
        password: this.registerForm.password,
        phone: this.registerForm.phone,
        code: this.registerForm.code,
      };
      Register( data ).then(( response ) => {
        // console.log( response );
        if(response.code === 2000){
          this.dialogFormVisible = false;
          this.$message.success({message:'注册成功',duration:1000,offset:400})
        }

      });
    },
    getYzm(){
      Code(  {phone: this.registerForm.phone}  ).then(( response ) => {
        this.timer();
        // console.log( response );
      });
    },
    timer() {//验证码倒计时
      let num = 60;
      let that = this;
      that.codeText = num + "秒后重新发送";
      let time = setInterval(function() {
        if(num == 0) {
          clearInterval(time);
          time = null;
          that.codeText = "重发验证码";
        } else {
          num--;
          that.codeText = num + "秒后重新发送";
        }

      }, 1000);
    },
  },
}
</script>

<style scoped>
>>>.el-dialog{
  background: url("../../../static/images/login-bg.png") no-repeat;
  background-size: 100% 100%;
  width: 690px;
  height: 450px;
}

>>>.login .el-button{
  width: 100%;
}

>>>.login .el-button--primary {
  background-color: #87b5f9;
   border-color: #87b5f9;
}

>>>.register .el-button{
  width: 100%;
}

>>>.register .el-button--primary {
  background-color: #87b5f9;
  border-color: #87b5f9;
}

>>>.el-tabs__nav-wrap::after{
 background-color: transparent;
}

>>>.el-dialog__body{
  display: flex;
  margin: 0 0 30px 60px;
}

>>>.el-tabs__item{
  padding: 0 100px;
}

.yzm{
  display: flex;
  gap: 10px;
}

.btn {
  border: 1px solid #c9c9c9;
  background-color: #fff;
  color: #555;
  letter-spacing: 2px;
  height: 40px;
  padding: 0 15px;
  border-radius: 3px;
}

.cursorPointer {
  cursor: pointer;
}

>>>.reg .el-form-item {
  margin-bottom: 10px;
}

>>>.btnBg {
  background-color: rgb(0, 22, 70)!important;
  border-color: rgb(0, 22, 70)!important;
}

.noPwd{
  text-align: right;
  color: #87B5F9;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue